import React from 'react';
import {NavLink} from "react-router-dom";
import {LuDatabaseBackup, LuLayoutDashboard} from "react-icons/lu";
import {GiReturnArrow} from "react-icons/gi";

const Navbar = (props) => {


    return (
        <React.Fragment>
            <aside id="sidebar" className="sidebar rtl">

                <ul className="sidebar-nav" id="sidebar-nav">

                    <li className="nav-item">
                        <NavLink to='/home'
                                 className={props.page === 'home' ? "nav-link" : "nav-link collapsed"}
                                 role="button"
                        >
                            <LuLayoutDashboard className='ms-2 nav-icon'/>
                            <span>سفارش های آماده ارسال </span>
                        </NavLink>
                    </li>

                    <li className="nav-item">
                        <NavLink to='/orders'
                                 className={props.page === 'orders' ? "nav-link" : "nav-link collapsed"}
                                 role="button"
                        >
                            <LuLayoutDashboard className='ms-2 nav-icon'/>
                            <span>سفارش های ارسال شده</span>
                        </NavLink>
                    </li>
                    <li className="nav-item">
                        <NavLink to='/returned-orders'
                                 className={props.page === 'returned-orders' ? "nav-link" : "nav-link collapsed"}
                                 role="button"
                        >
                            <GiReturnArrow className='ms-2 nav-icon'/>
                            <span>محموله های مرجوعی</span>
                        </NavLink>
                    </li>

                    <li className="nav-item">
                        <NavLink to='/sb-orders'
                                 className={props.page === 'sb-orders' ? "nav-link" : "nav-link collapsed"}
                                 role="button"
                        >
                            <LuDatabaseBackup className='ms-2 nav-icon'/>
                            <span>  سفارش های  برگشت از فروش  </span>
                        </NavLink>
                    </li>

                    <li className="nav-item">
                        <NavLink to='/sb-orders-qc'
                                 className={props.page === 'sb-orders-qc' ? "nav-link" : "nav-link collapsed"}
                                 role="button"
                        >
                            <LuDatabaseBackup className='ms-2 nav-icon'/>
                            <span>   برگشت از فروش  تایید شده</span>
                        </NavLink>
                    </li>

                </ul>

            </aside>
        </React.Fragment>
    );
};

export default Navbar;
